var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'VisualButtonHorizontal',
    {
      isActive: _vm.isActive,
      fitWidth: _vm.variant.width === 'fit',
      disabled: _vm.variant.type === 'disabled',
      focus: _vm.variant.focus
    }
  ],style:({ color: _vm.variant.color }),on:{"click":function($event){return _vm._onClickButton($event)}}},[_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }